import BaseModel from "../default/base-model";

export class Customer extends BaseModel {
    name?: string;

    constructor() {
        super();
        this.name = "";
    }
}
